<template>
  <el-container v-title data-title="班级列表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item>班级信息</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="名称">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getClassList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="schoolName" label="学校"></el-table-column>
          <el-table-column prop="countOfUser" label="总人数"></el-table-column>
          <el-table-column prop="countOfStudent" label="学生人数"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getClassList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="90px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="modifyData.schoolId" @change="getGradeList(modifyData.schoolId)" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级" prop="gradeId">
            <el-select v-model="modifyData.gradeId">
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyClass">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="90px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="addData.schoolId" @change="getGradeList(addData.schoolId)" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级" prop="gradeId">
            <el-select v-model="addData.gradeId">
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addClass">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: ''
      },
      modifyData: {},
      modifyDialogVisible: false,
      addData: {},
      addDialogVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }]
      },
      schoolList: [],
      gradeList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getClassList()
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getClassList()
    },
    openModifyDialog (classData) {
      this.gradeList = []
      this.modifyData = JSON.parse(JSON.stringify(classData))
      if (this.modifyData.schoolId != null) {
        this.getGradeList(this.modifyData.schoolId)
      }
      this.modifyDialogVisible = true
    },
    modifyClass () {
      let _this = this
      console.log(_this.modifyData)
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/class/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getClassList()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      this.$refs['modifyForm'].resetFields()
    },
    openAddDialog () {
      this.gradeList = []
      this.addDialogVisible = true
    },
    addClass () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/class/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData = {}
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getClassList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          name: _this.searchForm.name,
          schoolId: _this.searchForm.schoolId,
          countFlag: 1,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getGradeList (schoolId) {
      if (schoolId != null) {
        let _this = this
        _this.loading = true
        this.$axios.post(this.GLOBAL.host + '/grade/list',
          this.$qs.stringify({
            schoolId: schoolId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.gradeList = res.data.data.list
            } else {
              this.$message.error(res.data.message)
            }
          }
          _this.loading = false
        })
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Class.vue